import { datadogRum } from '@datadog/browser-rum';
import type { AnswerAction } from '@/entities/answer/model/actions';
import type { BranchId } from '@/shared/config/funnel/constants';
import type { FlattenedFunnelConfig } from '@/shared/config/funnel/flattened/types';
import { beginPendingBranchSwitch } from '../pendingBranchSwitch';
import type { FunnelInterrupt, InterruptAction, InterruptNavigatingOutcome } from './types';

type ApplyInterruptOutcomeDeps = {
  dispatch: (action: AnswerAction) => void;
  goToStep: (stepId: string, branchId: BranchId) => void;
  funnelFlattenedConfig: FlattenedFunnelConfig;
};

export function applyInterruptOutcome(
  outcome: InterruptNavigatingOutcome,
  { dispatch, goToStep, funnelFlattenedConfig }: ApplyInterruptOutcomeDeps,
): void {
  switch (outcome.kind) {
    case 'reset-branch': {
      const entry = funnelFlattenedConfig.branches[outcome.branchId].entry;
      // Allow landing to ignore URL/session mismatch until navigation lands.
      beginPendingBranchSwitch(outcome.branchId);
      dispatch({ type: 'RESET_BRANCH', branchId: outcome.branchId });
      goToStep(entry, outcome.branchId);
      return;
    }
  }
}

export function getInterruptAction(
  interruptId: string,
  actionId: string,
  interrupts: readonly FunnelInterrupt[],
): InterruptAction | undefined {
  const interrupt = interrupts.find(item => item.id === interruptId);
  if (!interrupt) {
    datadogRum.addError(new Error(`Interrupt not found: ${interruptId}`));
    return undefined;
  }
  const action = interrupt.actions.find(item => item.id === actionId);
  if (!action) {
    datadogRum.addError(new Error(`Interrupt action not found: ${interruptId}/${actionId}`));
    return undefined;
  }
  return action;
}
